import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import MeetingsHome from './Home'
import NewMeeting from './NewMeeting'
import MeetingDetail from './MeetingDetail'
import EditMeeting from './EditMeeting'

function Meetings () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <MeetingsHome />
      </SecureRoute>
      <SecureRoute path={`${path}/new`} exact>
        <NewMeeting />
      </SecureRoute>
      <SecureRoute path={`${path}/:meetingId/edit`} exact>
        <EditMeeting />
      </SecureRoute>
      <SecureRoute path={`${path}/:meetingId`} exact>
        <MeetingDetail />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default Meetings
